import { fork, takeEvery, all } from 'redux-saga/effects';
import {
  ManagerApi,
  ManagerControllerDtoManagerLoginLogListRequest,
  ManagerControllerDtoManagerTwoFactorLogListRequest,
  ManagerControllerDtoManagerWorkedLogListRequest,
} from '../../models/src';
import config from '../../../config/config';
import {
  MANAGER_LOGIN_LOG_LIST_REQUEST,
  MANAGER_TWOFACTOR_LOG_LIST_REQUEST,
  MANAGER_WORKED_LOG_LIST_REQUEST,
} from '../../constants/backoffice/logConstants';
import ManagerControllerDtoManagerLoginLogListResponse
  from '../../models/src/model/ManagerControllerDtoManagerLoginLogListResponse';
import ManagerControllerDtoManagerTwoFactorLogListResponse
  from '../../models/src/model/ManagerControllerDtoManagerTwoFactorLogListResponse';
import ManagerControllerDtoManagerWorkedLogListResponse
  from '../../models/src/model/ManagerControllerDtoManagerWorkedLogListResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new ManagerApi(config.API_CLIENT);

// function getUrlVars() {
//   const vars = {};
//   const parts = window.location.href.replace(
//     /[?&]+([^=&]+)=([^&]*)/gi,
//     function (m, key, value) {
//       // eslint-disable-line
//       vars[key] = value;
//     },
//   );
//   return vars;
// }

//= ====================================
//  WATCHERS
//-------------------------------------

function* loginLogListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerLoginLogListRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchCode = payload.searchCode;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerLoginLogListPost({ managerControllerDtoManagerLoginLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoManagerLoginLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* twoFactorLogListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerTwoFactorLogListRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchCode = payload.searchCode;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerTwofactorLogListPost({ managerControllerDtoManagerTwoFactorLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoManagerTwoFactorLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* workedLogListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerWorkedLogListRequest();
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchCode = payload.searchCode;
    requestData.searchString = payload.searchString;
    requestData.noteSearch = payload.noteSearch;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerWorkedLogListPost({ managerControllerDtoManagerWorkedLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoManagerWorkedLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* logRootSaga() {
  yield all([
    takeEvery(MANAGER_LOGIN_LOG_LIST_REQUEST, loginLogListSaga),
    takeEvery(MANAGER_TWOFACTOR_LOG_LIST_REQUEST, twoFactorLogListSaga),
    takeEvery(MANAGER_WORKED_LOG_LIST_REQUEST, workedLogListSaga),
  ]);
}

const logSagas = [fork(logRootSaga)];

export default logSagas;
